// mui
import { Container, Box, Stack } from '@mui/material';

import { alpha } from '@mui/material/styles';

// client-shared
import { display } from '@goldblack/client-utils';
import { rotateBorderKeyframes } from '@goldblack/client-comps';

function ContainerMain(props) {
    // 2. 테두리 애니메이션 스타일 생성 함수
    const getAnimatedBorderStyles = (theme, hasBorder) => ({
        display: 'flex',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
        borderRadius: '10px',
        padding: '1.5px',
        ...rotateBorderKeyframes, // 키프레임 포함

        ...(hasBorder && {
            backgroundColor: alpha(theme.palette.primary.main, 0.5),
            '&::before': {
                content: '""',
                position: 'absolute',
                width: '150%',
                height: '150%',
                top: '-25%',
                left: '-25%',
                background: `conic-gradient(transparent, ${theme.palette.primary.light}, transparent 20%)`,
                animation: 'rotateWithPause 60s linear infinite',
            },
            '&::after': {
                content: '""',
                position: 'absolute',
                inset: '1.5px',
                backgroundColor: theme.palette.background.default,
                borderRadius: '8.5px',
                zIndex: 0,
            },
        }),
    });

    return (
        <Container
            component='main'
            id={props.layer}
            hidden={props.hidden}
            maxWidth={props.width}
            disableGutters
            sx={{
                backgroundColor: 'background.default',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '100%',
                height: display.formatVhString(props.config.commonMinHeight),
                overflow: 'hidden',
                display: props.hidden ? 'none' : 'flex',
            }}>
            <Box sx={(theme) => getAnimatedBorderStyles(theme, props.border)}>
                <Stack
                    direction='column'
                    sx={{
                        width: '100%',
                        height: '100%',
                        zIndex: 1,
                        overflow: 'hidden',
                        minHeight: 0,
                    }}>
                    {props.top ? (
                        <Box sx={{ borderBottom: 1, borderColor: 'primary.dark', flexShrink: 0 }}>
                            {props.topContent ? props.topContent : <></>}
                        </Box>
                    ) : (
                        <></>
                    )}

                    {/* body가 남는 높이를 모두 흡수 */}
                    <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden', pt: '1px' }}>{props.bodyContent}</Box>

                    {props.bottom ? (
                        <Box
                            sx={{
                                borderTop: 1,
                                borderColor: 'primary.dark',
                                flexShrink: 0,
                                overflow: 'hidden',
                                ...(props.config?.commonBottomMinHeight && {
                                    maxHeight: display.formatPxString(props.config.commonBottomMinHeight),
                                }),
                            }}>
                            {props.bottomContent ? props.bottomContent : <></>}
                        </Box>
                    ) : (
                        <></>
                    )}
                </Stack>
            </Box>
        </Container>
    );
}

export { ContainerMain };
